import { db } from '@/config/firebase'
import dbFilter from '@/helpers/firestoreQueryFilter'

export default {
  async getDrivers({ commit, rootState }) {
    const companyId = rootState.User.profile.company_id

    let userRef = db
      .collection('companies')
      .doc(companyId)
      .collection('users')
      .orderBy('name')
      .where('roles', 'array-contains', 'driver')

    let drivers = await dbFilter.query(userRef)
    commit('changeDrivers', drivers)
    return drivers
  },
}
